module.exports = __webpack_public_path__ + "img/img_web1_1@2x.6652cbb4.png";